import React from "react";

const NewUserIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.30603"
        y="0.572876"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#FDB52A"
      />
      <path
        d="M12.3492 24.6146C12.3492 22.3473 14.1873 20.5093 16.4546 20.5093H20.9917C23.2591 20.5093 25.0971 22.3473 25.0971 24.6146C25.0971 25.3704 24.4844 25.9831 23.7286 25.9831H13.7177C12.9619 25.9831 12.3492 25.3704 12.3492 24.6146Z"
        fill="#FDB52A"
      />
      <path
        d="M18.7255 19.4663C20.7316 19.4663 22.3579 17.8325 22.3579 15.8172C22.3579 13.8018 20.7316 12.168 18.7255 12.168C16.7194 12.168 15.0931 13.8018 15.0931 15.8172C15.0931 17.8325 16.7194 19.4663 18.7255 19.4663Z"
        fill="#FDB52A"
      />
    </svg>
  );
};

export default NewUserIcon;
